<app-page-layout [title]="'market_discovery.navigation.imports' | translate">
  <ng-container content>
    <cpb-list-renderer [key]="'list_import'" [context]="context$ | async"></cpb-list-renderer>
  </ng-container>
</app-page-layout>
